import axios from 'axios'
// import { BehaviorSubject } from 'rxjs';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : api
Description : Se encarga de la conección del frontend con las controladores del backend
Date Autor Modification
================================================================================
01/08/2022 Santiago Coca Rojas Creación – Se implementa el api desde cero.
================================================================================ */
// const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

/*Url api Backend  en el servidor*/
const apiRouter = axios.create({
    baseURL: process.env.REACT_APP_API_ROUTER,
    //baseURL: 'http://localhost:9091/'
})

const apiUser = axios.create({
    baseURL: localStorage.getItem('routerApi'),
    // baseURL: 'http://localhost:9090/'
})

const apiSecurity = axios.create({
    baseURL: process.env.REACT_APP_API_SECURITY_ENDPOINT
    // baseURL: 'http://localhost:9095/'
})

const apiSecuritySelf = axios.create({
    baseURL: localStorage.getItem('selfApi')
    // baseURL: 'http://localhost:9095/'
})

const apiEpayco = axios.create({
    baseURL: process.env.REACT_APP_API_EPAYCO_ENDPOINT,
    headers: {
        Authorization: "Basic " + btoa("REMUNER_LITE_PAYMENT:Remuner_Lite_pag0s.2022")
    }
})

const apiPython = axios.create({
    baseURL: 'http://127.0.0.1:9595/'
})

/*Firms API*/
export const postFirm = (payload, headerGroup) => apiUser.post(`/Configuration/PostConf_signature`, payload, { headers: headerGroup });
export const getFirm = (entity, headerGroup) => apiUser.get(`/Configuration/GetConf_signature/${entity}`, { headers: headerGroup });
export const putFirm = (payload, headerGroup) => apiUser.put(`/Configuration/PutConf_signature`, payload, { headers: headerGroup });
export const deleteFirm = (entity, id, headerGroup) => apiUser.delete(`/Configuration/DelConf_signature/${entity}/${id}`, { headers: headerGroup });
export const getValueListFirm = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_signature/${entity}`, { headers: headerGroup })

/*User real API*/
export const PostChange_password = (payload, headerGroup) => apiUser.post(`/users/PostChange_password`, payload, { headers: headerGroup })
export const saveUser = (payload, headerGroup) => apiSecurity.post(`/Security/saveUser`, payload, { headers: headerGroup });
export const saveUserToken = (payload) => apiSecurity.post(`/Security/saveUserToken`, payload)
export const getTimeNow = () => apiSecurity.get(`/Security/getTimeNow`)
export const getUserType = (headerGroup, contract = '') => apiUser.get(contract ? `/users/GetType_user_app/${contract}` : '/users/GetType_user_app', { headers: headerGroup })
export const acceptTerms = (payload, headerGroup) => apiUser.post('/users/PostLegal_terms_user', payload, { headers: headerGroup })

/*Identity real API*/

export const postIdentity = (payload, headerGroup) => apiUser.post(`/contract/PostIdentity`, payload, { headers: headerGroup });
export const putIdentity = (payload, headerGroup) => apiUser.put(`/contract/PutIdentity`, payload, { headers: headerGroup });
export const getIdentity = (entity, client, number_id, token, headerGroup) => apiUser.get(`/contract/GetIdentity/${entity}/${client}/${number_id}/${token}`, { headers: headerGroup });
export const getValueListIdentity = (headerGroup) => apiUser.get(`/lov_tables/GetList_create_person`, { headers: headerGroup });

/*Contract Real API*/

export const postContract = (payload, headerGroup) => apiUser.post(`/contract/PostContract`, payload, { headers: headerGroup });
export const putContract = (payload, headerGroup) => apiUser.put(`/contract/PutContract`, payload, { headers: headerGroup });
export const getContract = (entity, client, contract_id, headerGroup) => apiUser.get(`/contract/GetContract/${entity}/${client}/${contract_id}`, { headers: headerGroup });
export const getValueListContract = (entity, client, headerGroup) => apiUser.get(`/lov_tables/GetList_create_employee/${entity}/${client}`, { headers: headerGroup });
export const putContractSalary = (payload, headerGroup) => apiUser.put(`/contract/PutContract_salary`, payload, { headers: headerGroup });

/*Company real API */

export const postBusiness = (payload, headerGroup) => apiUser.post(`/business/PostBusiness`, payload, { headers: headerGroup });
export const putBusiness = (payload, headerGroup) => apiUser.put(`/business/PutBusiness`, payload, { headers: headerGroup });
export const getBusiness = (headerGroup) => apiUser.get(`/business/GetBusiness/`, { headers: headerGroup });
//export const getValueListCompany1 = (headerGroup) => apiUser.get(`/lov_tables/GetList_registration_process`, {headers: headerGroup});
export const getValueListCompany = (headerGroup) => apiUser.get(`/lov_tables/GetList_config_data_company`, { headers: headerGroup });

/*Holidays Real API*/

export const getValueListHolidays = (headerGroup) => apiUser.get(`/lov_tables/GetList_config_holidays`, { headers: headerGroup });
/*CIR Real API*/

export const postReportCIR = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_cir`, payload, { headers: headerGroup })

/*Calendar Real API*/
export const getValueListCalendar = (calendar_type, headerGroup) => apiUser.get(`/process/GetCalendar/${calendar_type}`, { headers: headerGroup });
export const getLastCalendar = (entity, headerGroup) => apiUser.get(`/process/GetLast_Calendar_payroll/${entity}`, { headers: headerGroup });
export const getNoveltiesCalendar = (headerGroup) => apiUser.get(`/process/GetCalendar_novelties/NM`, { headers: headerGroup })

/*PayrollPayment Real API*/

export const executeProcess = (payload, headerGroup) => apiUser.post(`/process/PostExecute_Process`, payload, { headers: headerGroup })
export const getExecutedProcess = (calendar, entity, action, headerGroup) => apiUser.get(`/process/GetProcess_executed/${calendar}/${entity}/${action}`, { headers: headerGroup })
export const getBankFlat = (entity, date_pay, id_calendar, headerGroup) => apiUser.get(`/files_raw/GetBank_flat_file/${entity}/${date_pay}/${id_calendar}`, { headers: headerGroup })
export const postReportPayroll = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_nom`, payload, { headers: headerGroup })
export const postReportSalaryHistory = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_His_salary`, payload, { headers: headerGroup })
export const postReportHeadCount = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_head_count`, payload, { headers: headerGroup })

/*SocialSecurity API*/
export const postReportSocialSecurity = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_sso`, payload, { headers: headerGroup })

/*Archivo plano Real API*/
export const getValueFiles_raw = (entity, id_calendar, headerGroup) => apiUser.get(`/files_raw/GetPila_flat_file/${entity}/${id_calendar}`, { headers: headerGroup });

/*Reporte detallado Contabilidad API*/
export const postReportAccounting = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_ctb`, payload, { headers: headerGroup });

/*Reporte detallado Cesantias API*/
export const postReportSeverance = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_cess`, payload, { headers: headerGroup });
export const postReportFlatSeverance = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_flat_file_cess`, payload, { headers: headerGroup });

/*Login API*/
export const postLogin = (payload) => apiRouter.post(`/Router/login`, payload);

/*Login API*/
export const getContracts_client = (entity, headerGroup) => apiUser.get(`/contract/GetContracts_client/${entity}`, { headers: headerGroup });
/*Overtime API*/

export const getOvertimeLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_He_and_Rn/${entity}`, { headers: headerGroup })
export const postOvertime = (payload, headerGroup) => apiUser.post(`/novelties/PostHe_and_Rn`, payload, { headers: headerGroup })
export const getOvertime = (entity, occasional_id, headerGroup) => apiUser.get(`/novelties/GetHe_and_Rn/${entity}/${occasional_id}`, { headers: headerGroup })
export const putOvertime = (payload, headerGroup) => apiUser.put(`/novelties/PutHe_and_Rn/`, payload, { headers: headerGroup })
export const deleteOvertime = (entity, occasional_id, headerGroup) => apiUser.delete(`/novelties/DelHe_and_Rn/${entity}/${occasional_id}`, { headers: headerGroup })

/*Vacation API*/

export const getVacationLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Mod_Vac/${entity}`, { headers: headerGroup })
export const postVacation = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_vacation`, payload, { headers: headerGroup })
export const getVacation = (entity, vacation_id, headerGroup) => apiUser.get(`/novelties/GetNov_vacation/${entity}/${vacation_id}`, { headers: headerGroup })
export const putVacation = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_vacation/`, payload, { headers: headerGroup })
export const deleteVacation = (entity, vacation_id, headerGroup) => apiUser.delete(`/novelties/DelNov_vacation/${entity}/${vacation_id}`, { headers: headerGroup })
export const getEnd_DateVacation = (entity, date_ini, days, contrac_id, headerGroup) => apiUser.get(`/novelties/GetEnd_date_vacation/${entity}/${date_ini}/${days}/${contrac_id}`, { headers: headerGroup })
export const getValidDateIni = (entity, date_ini, contrac_id, headerGroup) => apiUser.get(`/novelties/GetValidated_business_day/${entity}/${date_ini}/${contrac_id}`, { headers: headerGroup })
export const postReportVacationHistory = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_His_vacation`, payload, { headers: headerGroup })

/*Reported API*/

export const getReportedLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Coc_Oca/${entity}`, { headers: headerGroup })
export const postReported = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_reported`, payload, { headers: headerGroup })
export const getReported = (entity, occasional_id, headerGroup) => apiUser.get(`/novelties/GetNov_reported/${entity}/${occasional_id}`, { headers: headerGroup })
export const putReported = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_reported`, payload, { headers: headerGroup })
export const deleteReported = (entity, occasional_id, headerGroup) => apiUser.delete(`/novelties/DelNov_reported/${entity}/${occasional_id}`, { headers: headerGroup })
export const getValueListReportedConcepts = (headerGroup) => apiUser.get(`/lov_tables/GetList_mod_concepts`, { headers: headerGroup })
export const postReportedConcept = (payload, headerGroup) => apiUser.post(`/Configuration/PostConcept`, payload, { headers: headerGroup })
export const getReportedConcept = (entity, concept, headerGroup) => apiUser.get(`/Configuration/GetConcept/${entity}/${concept}`, { headers: headerGroup })
export const putReportedConcept = (payload, headerGroup) => apiUser.put(`/Configuration/PutConcept`, payload, { headers: headerGroup })
export const deleteReportedConcept = (entity, concept, module, headerGroup) => apiUser.delete(`/Configuration/DelConcept/${entity}/${concept}/${module}`, { headers: headerGroup })


/*Licenses API*/

export const getLicensesLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Mod_Abs/${entity}`, { headers: headerGroup })
export const postLicenses = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_absence`, payload, { headers: headerGroup })
export const getLicenses = (entity, absence_id, headerGroup) => apiUser.get(`/novelties/GetNov_absence/${entity}/${absence_id}`, { headers: headerGroup })
export const putLicenses = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_absence`, payload, { headers: headerGroup })
export const deleteLicenses = (entity, absence_id, headerGroup) => apiUser.delete(`/novelties/DelNov_absence/${entity}/${absence_id}`, { headers: headerGroup })
// export const getLicenseEndDate = (entity, startDate, time, contract_id, headerGroup) => apiUser.get(`/novelties/GetEnd_date_absence/${entity}/${startDate}/${time}/${contract_id}`, { headers: headerGroup })
export const getLicenseExtension = (entity, contract_id, contingency, headerGroup) => apiUser.get(`/novelties/GetNovAbs_extension/${entity}/${contract_id}/${contingency}`, { headers: headerGroup })
export const postReportLicenseHistory = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_His_absence`, payload, { headers: headerGroup })

/*Statics API*/

export const getStaticsLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Coc_Sta/${entity}`, { headers: headerGroup })
// export const getConcepLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Coc_Sta/${entity}`, {headers: headerGroup})
export const postStatics = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_Statics`, payload, { headers: headerGroup })
export const getStatics = (entity, static_id, headerGroup) => apiUser.get(`/novelties/GetNov_Statics/${entity}/${static_id}`, { headers: headerGroup })
export const putStatics = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_Statics/`, payload, { headers: headerGroup })
export const deleteStatics = (entity, absence_id, headerGroup) => apiUser.delete(`/novelties/DelNov_Statics/${entity}/${absence_id}`, { headers: headerGroup })


/*Social_benefits API*/

export const getSocial_benefitsLists = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_Mod_termination/${entity}`, { headers: headerGroup })
export const postSocial_benefits = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_termination`, payload, { headers: headerGroup })
export const getSocial_benefits = (entity, Social_benefits_id, headerGroup) => apiUser.get(`/novelties/GetNov_termination/${entity}/${Social_benefits_id}`, { headers: headerGroup })
export const putSocial_benefits = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_termination`, payload, { headers: headerGroup })
export const deleteSocial_benefits = (entity, Social_benefits_id, headerGroup) => apiUser.delete(`/novelties/DelNov_termination/${entity}/${Social_benefits_id}`, { headers: headerGroup })

/*Social_benefits API*/

export const getUsersList = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_users/${entity}`, { headers: headerGroup })
export const postUsers = (payload, headerGroup) => apiUser.post(`/users/PostUser_entity`, payload, { headers: headerGroup })
export const getUsers = (entity, userid, headerGroup) => apiUser.get(`/users/GetUser_entity/${entity}/${userid}`, { headers: headerGroup })
export const putUsers = (payload, headerGroup) => apiUser.put(`/users/PutUser_entity`, payload, { headers: headerGroup })
export const deleteUsers = (entity, Social_benefits_id, headerGroup) => apiUser.delete(`/users/DelUser_entity/${entity}/${Social_benefits_id}`, { headers: headerGroup })

/*Jobs API*/

export const postJobs = (payload, headerGroup) => apiUser.post(`/business/PostJob`, payload, { headers: headerGroup })
export const getJobs = (entity, userid, headerGroup) => apiUser.get(`/business/GetJob/${entity}/${userid}`, { headers: headerGroup })
export const putJobs = (payload, headerGroup) => apiUser.put(`/business/PutJob`, payload, { headers: headerGroup })
export const deleteJobs = (entity, Social_benefits_id, headerGroup) => apiUser.delete(`/business/DelJob/${entity}/${Social_benefits_id}`, { headers: headerGroup })


/*Cost Center API*/

export const getCenCosList = (headerGroup) => apiUser.get(`/lov_tables/GetList_mod_cencos/`, { headers: headerGroup })
export const postCenCos = (payload, headerGroup) => apiUser.post(`/Configuration/PostConf_cencos`, payload, { headers: headerGroup })
export const getCenCos = (entity, userid, headerGroup) => apiUser.get(`/Configuration/GetConf_cencos/${entity}/${userid}`, { headers: headerGroup })
export const putCenCos = (payload, headerGroup) => apiUser.put(`/Configuration/PutConf_cencos`, payload, { headers: headerGroup })
export const deleteCenCos = (entity, cencosId, headerGroup) => apiUser.delete(`/Configuration/DelConf_cencos/${entity}/${cencosId}`, { headers: headerGroup })


/*Plan de cuentas conrtables API*/

export const getValNit = (entity, nit, headerGroup) => apiUser.get(`/Configuration/GetVal_nit_account/${entity}/${nit}`, { headers: headerGroup })
export const getAccountList = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_account/${entity}`, { headers: headerGroup })
export const postAccount = (payload, headerGroup) => apiUser.post(`/Configuration/PostParameters_account`, payload, { headers: headerGroup })
export const getAccount = (entity, accountId, headerGroup) => apiUser.get(`/Configuration/GetParameters_account/${entity}/${accountId}`, { headers: headerGroup })
export const putAccount = (payload, headerGroup) => apiUser.put(`/Configuration/PutParameters_account`, payload, { headers: headerGroup })
export const deleteAccount = (entity, accountId, headerGroup) => apiUser.delete(`/Configuration/DelParameters_account/${entity}/${accountId}`, { headers: headerGroup })
export const getAccountListDocumentType = (headerGroup) => apiUser.get(`/lov_tables/GetList_files_raw_ctb`, { headers: headerGroup })
export const postReportAccount = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_by_Name`, payload, { headers: headerGroup })

/*Payroll Configuration API*/

export const getPayrollConf = (entity, headerGroup) => apiUser.get(`/Configuration/GetConf_payroll/${entity}`, { headers: headerGroup })
export const putPayrollConf = (payload, headerGroup) => apiUser.put(`/Configuration/PutConf_payroll`, payload, { headers: headerGroup })
export const getPayrollGroupConf = (entity, idGroup, headerGroup) => apiUser.get(`/Configuration/GetConf_payroll_group/${entity}/${idGroup}`, { headers: headerGroup })
export const postPayrollGroupConf = (payload, headerGroup) => apiUser.post(`/Configuration/PostConf_payroll_group`, payload, { headers: headerGroup })
export const deletePayrollGroupConf = (entity, idGroup, concept, headerGroup) => apiUser.delete(`/Configuration/DelConf_payroll_group/${entity}/${idGroup}/${concept}`, { headers: headerGroup })
export const getValueListPayrollConf = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_config_payroll/${entity}`, { headers: headerGroup })
export const getConceptsPayrollConf = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_config_payroll_concepts/${entity}`, { headers: headerGroup })

/*Third API*/

export const getThirdList = (headerGroup) => apiUser.get(`/lov_tables/GetList_mod_third`, { headers: headerGroup })
export const postThird = (payload, headerGroup) => apiUser.post(`/Configuration/PostThird_account`, payload, { headers: headerGroup })
export const getThird = (entity, userid, headerGroup) => apiUser.get(`/Configuration/GetThird_account/${entity}/${userid}`, { headers: headerGroup })
export const putThird = (payload, headerGroup) => apiUser.put(`/Configuration/PutThird_account`, payload, { headers: headerGroup })
export const deleteThird = (entity, cencosId, headerGroup) => apiUser.delete(`/Configuration/DelThird_account/${entity}/${cencosId}`, { headers: headerGroup })

/**Get Token */
export const getToken = (headerGroup) => apiUser.get(`/Security/getToken`, { headers: headerGroup })


/*CIR configuration API */

export const getCIRConfList = (entity, option, headerGroup) => apiUser.get(`/lov_tables/GetList_config_cir/${entity}/${option}`, { headers: headerGroup })
export const postCIRConf = (payload, headerGroup) => apiUser.post(`/Configuration/PostConfig_Cir`, payload, { headers: headerGroup })
export const getCIRConf = (entity, idGroup, headerGroup) => apiUser.get(`/Configuration/GetConfig_Cir/${entity}/${idGroup}`, { headers: headerGroup })
export const deleteCIRConf = (entity, idGroup, concept, headerGroup) => apiUser.delete(`/Configuration/DelConfig_Cir/${entity}/${idGroup}/${concept}`, { headers: headerGroup })
export const confReport = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_config_cyr`, payload, { headers: headerGroup })

/*OpenPayroll API*/

export const getValueListOpenPayroll = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_query_acc/${entity}`, { headers: headerGroup })
export const postOpenPayroll = (payload, headerGroup) => apiUser.post(`/queries/PostPayroll_open`, payload, { headers: headerGroup })

/*HistoricPayroll API*/

export const getValueListHistoricPayroll = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_query_acc/${entity}`, { headers: headerGroup })
export const postHistoricPayroll = (payload, headerGroup) => apiUser.post(`/queries/PostPayroll_accumulated`, payload, { headers: headerGroup })
export const uploadHistoricPayroll = (payload, headerGroup) => apiUser.post(`/upload/PostUpload_accum_hist`, payload, { headers: headerGroup })

/*HistoricSocialSecurity API*/

export const getValueListHistoricSocialSecurity = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_query_sso/${entity}`, { headers: headerGroup })
export const postHistoricSocialSecurity = (payload, headerGroup) => apiUser.post(`/queries/PostSocial_security`, payload, { headers: headerGroup })

/*HistoricAccounting API*/

export const getValueListHistoricAccounting = (entity, headerGroup) => apiUser.get(`/lov_tables/GetList_mod_query_ctb/${entity}`, { headers: headerGroup })
export const postHistoricAccounting = (payload, headerGroup) => apiUser.post(`/queries/PostAux_Account`, payload, { headers: headerGroup })


/*Password*/

export const postSendEmail = (payload) => apiSecurity.post(`/Security/getToken`, payload)
export const postUpdatePassword = (payload) => apiSecurity.post(`/Security/updatePassword`, payload)
/*ElectronicPayroll API*/

export const postReportElectronicPayroll = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_mod_ne`, payload, { headers: headerGroup })
export const getTransferDataElectronicPayroll = (entity, calendar, headerGroup) => apiUser.get(`/process/GetTransfer_data_ne/${entity}/${calendar}`, { headers: headerGroup })
export const postTransferElectronicPayroll = (payload, headerGroup) => apiUser.post(`/process/PostSend_Xml`, payload, { headers: headerGroup })
export const putCune = (payload, headerGroup) => apiUser.put(`/process/PutCune_Xml`, payload, { headers: headerGroup })
export const electronicPayrollConf = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_config_ne`, payload, { headers: headerGroup })

/*Support API*/

export const postSupportMail = (payload, headerGroup) => apiUser.post(`/support/PostSend_mail_support`, payload, { headers: headerGroup })


/*Modal pago nómina anterior API*/
export const getPayment = (entity, headerGroup) => apiUser.get(`/process/GetLastPayroll_payment/${entity}`, { headers: headerGroup })


/*Generate PDF API*/

export const postPDF = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_pdf_ex`, payload, { headers: headerGroup })

/*DIAN Process API*/
export const getListDIANProcess = (headerGroup) => apiUser.get(`/lov_tables/Getlist_enabling_process`, { headers: headerGroup })
export const postDIANProcess = (payload, headerGroup) => apiUser.post(`/Configuration/PostEnable_config_ne`, payload, { headers: headerGroup })
export const putDIANProcess = (payload, headerGroup) => apiUser.put(`/Configuration/PutEnable_config_ne`, payload, { headers: headerGroup })
export const getDIANProcess = (entity, headerGroup) => apiUser.get(`/Configuration/GetEnable_config_ne/${entity}`, { headers: headerGroup })
export const validateDIANProcess = (entity, headerGroup) => apiUser.get(`/Configuration/GetValidate_Enable_config_ne/${entity}`, { headers: headerGroup })

/*Generate PDF Voucher API*/
export const postPDFVoucher = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_pdf_voucher`, payload, { headers: headerGroup })
export const getVouchers = (payload, headerGroup) => apiUser.post(`/files_raw/PostRecords_pdf_voucher`, payload, { headers: headerGroup })

/*Verification code API*/

export const postVerificationCode = (payload, headerGroup) => apiUser.post(`/users/PostCode_user`, payload, { headers: headerGroup })
export const getVerificationCode = (headerGroup) => apiUser.get(`/users/GetCode_user`, { headers: headerGroup })

/*Endpoints Integracion ePayco */
export const getEpaycoParams = (headerGroup) => apiEpayco.get(`/remuner-lite/epayco/api/params/get`, { headers: headerGroup })
export const getEpaycoTransactions = (entity, headerGroup) => apiEpayco.get(`/remuner-lite/epayco/api/transaction/get?params=${entity}`, { headers: headerGroup })
export const postEpaycoTransaction = (user, params, headerGroup) => apiEpayco.post(`/remuner-lite/epayco/api/transaction/save?user=${user}&params=${params}`, { headers: headerGroup })
export const getCustomerInformation = (entity, headerGroup) => apiEpayco.get(`/remuner-lite/epayco/customer/api/get?entity=${entity}`, { headers: headerGroup })

/*Lista de endpoints*/
export const postLegalTerms = (payload) => apiSecurity.post(`/Security/postLegalTerms`, payload);

/*Lista de endpoints para datos en pantalla de inicio*/
export const getGetPayroll_budget = (entity, headerGroup) => apiUser.get(`/process/GetPayroll_budget/${entity}`, { headers: headerGroup })
export const getGetEmployee_budget = (entity, headerGroup) => apiUser.get(`/process/GetEmployee_budget/${entity}`, { headers: headerGroup })
export const GetPending_invoices = (entity, headerGroup) => apiUser.get(`/process/GetPending_invoices/${entity}`, { headers: headerGroup })
export const getPassiveLabor = (entity, headerGroup) => apiUser.get(`/process/GetPassive_labor/${entity}`, { headers: headerGroup })
export const getTotalPassiveLabor = (entity, headerGroup) => apiUser.get(`/process/GetTotal_Passive_labor/${entity}`, { headers: headerGroup })
export const getPayAbsenceType = (entity, headerGroup) => apiUser.get(`/process/GetPay_Absence_type/${entity}`, { headers: headerGroup })
export const getPayAbsenceDays = (entity, headerGroup) => apiUser.get(`/process/GetPay_Absence_days/${entity}`, { headers: headerGroup })

/*Endpoints certificados de ingresos y retenciones */

export const getCIRVouchers = (payload, headerGroup) => apiUser.post(`/files_raw/PostRecords_pdf_cyr`, payload, { headers: headerGroup })
export const postPDFCIRVoucher = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_pdf_cyr`, payload, { headers: headerGroup })

/*Endpoints medios magnéticos*/

export const getFormat1009 = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_format_1009`, payload, { headers: headerGroup })
export const getFormat2276 = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_format_2276`, payload, { headers: headerGroup })


/*Endpoints cconsulta NE*/

export const getReadDataElectronicPayroll = (entity, year, month, headerGroup) => apiUser.get(`/process/GetTransfer_data_ne_ym/${entity}/${year}/${month}`, { headers: headerGroup })

/*Endpoint mesajes de información*/

export const getInfoMessages = (page, headerGroup) => apiUser.get(`/pages/GetPages_messages/${page}`, { headers: headerGroup })

/*Endpoints retefuente*/

export const getRetefuenteReports = (payload, headerGroup) => apiUser.post(`/files_raw/PostRecords_pdf_retention`, payload, { headers: headerGroup })
export const postRetefuenteReport = (payload, headerGroup) => apiUser.post(`/files_raw/PostReports_pdf_retention`, payload, { headers: headerGroup })

/*Endpoint validación carta laboral*/

export const getValidateCertificate = (id) => apiSecurity.get(`/queries/GetValid_information/${id}`)

/*Endpoints solicitudes*/

export const getRequestList = (entity, client, contract, headerGroup) => apiUser.get(`/lov_tables/GetList_Req_selfservices/${entity}/${client}/${contract}`, { headers: headerGroup })
export const getVacationEndDate = (entity, client, date, unity, contract, headerGroup) => apiUser.get(`/novelties/GetEnd_date_vacation/${entity}/${client}/${date}/${unity}/${contract}`, { headers: headerGroup })
export const getLicenseEndDate = (entity, client, date, unity, contract, headerGroup) => apiUser.get(`/novelties/GetEnd_date_absence/${entity}/${client}/${date}/${unity}/${contract}`, { headers: headerGroup })
export const postRequest = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_selfservices`, payload, { headers: headerGroup })
export const getAllRequests = (entity, client, status, contract, initDate, endDate, headerGroup) => apiUser.get(`/novelties/GetNov_selfservices_client/${entity}/${client}/${status}/${contract}/${initDate}/${endDate}`, { headers: headerGroup })
export const getRequest = (entity, client, request, headerGroup) => apiUser.get(`/novelties/GetNov_selfservices/${entity}/${client}/${request}`, { headers: headerGroup })
export const getPendRequests = (entity, client, headerGroup) => apiUser.get(`/lov_tables/GetList_Pend_selfservices/${entity}/${client}`, { headers: headerGroup })
export const putRequests = (payload, headerGroup) => apiUser.put(`/novelties/PutNov_selfservices_client`, payload, { headers: headerGroup })
export const deleteRequest = (entity, client, request, headerGroup) => apiUser.delete(`/novelties/DelNov_selfservices/${entity}/${client}/${request}`, { headers: headerGroup })
export const requestGraph = (payload, headerGroup) => apiUser.post(`/novelties/PostGraph_selfservices_mod`, payload, { headers: headerGroup })
export const getNovContracts = (payload, headerGroup) => apiUser.post(`/novelties/PostEmp_selfservices_mod`, payload, { headers: headerGroup })
export const getRequestListAdd = (entity, client, contract, type, headerGroup) => apiUser.get(`/lov_tables/GetList_Req_selfservices_add/${entity}/${client}/${contract}/${type}`, { headers: headerGroup })
export const noveltyCauseList = (entity, client, headerGroup) => apiUser.get(`/lov_tables/GetList_Nov_turn_causal/${entity}/${client}`, { headers: headerGroup })

/*Endpoint archivos*/

export const postFileS3 = (payload, headerGroup) => apiUser.post(`/python/postFile`, payload, { headers: headerGroup })

/*Captcha endpoint*/

export const postCaptcha = (payload) => apiSecurity.post(`/Security/postCaptcha`, payload)

/*Endpoint habilitación usuarios*/

export const activateUser = (payload) => apiSecurity.post(`/users/PostCreate_SelfService_user`, payload)

/*Endpoint instancias*/

export const postInstanceAction = (payload, headerGroup) => apiUser.post(`/instances/PostInstances`, payload, { headers: headerGroup })
export const getInstanceLists = (headerGroup) => apiUser.get(`/instances/GetList_Instances`, { headers: headerGroup })

/*Endpoints tracking*/

export const postImageRecognition = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_captured_image`, payload, { headers: headerGroup })
export const postTrackingNovelty = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_catch_novelty`, payload, { headers: headerGroup })
export const getEmployeesNovelties = (payload, headerGroup) => apiUser.post(`/novelties/PostEmp_selfservices_novelties`, payload, { headers: headerGroup })
export const getTrackingNovelties = (payload, headerGroup) => apiUser.post(`/novelties/PostNov_selfservices_trk`, payload, { headers: headerGroup })
export const getTrackingEmployees = (payload, headerGroup) => apiUser.post(`/novelties/PostEmp_selfservices_mod_trk`, payload, { headers: headerGroup })

/*Endpoints turnos*/

export const getShiftsLists = (entity, client, contract, year = "", headerGroup) => apiUser.get(`/lov_tables/GetList_Turn_selfservices/${entity}/${client}/${contract}/${year}`, { headers: headerGroup })
export const getShifts = (entity, client, contract = "NULL", year = "", startDate, endDate, headerGroup) => apiUser.get(`/contract/GetContract_scheduling/${entity}/${client}/${contract}/${year}/${startDate}/${endDate}`, { headers: headerGroup })
export const postShift = (payload, headerGroup) => apiUser.post(`/contract/PostContract_scheduling`, payload, { headers: headerGroup })
export const deleteShift = (entity, client, id, headerGroup) => apiUser.delete(`/contract/DelContract_scheduling/${entity}/${client}/${id}`, { headers: headerGroup })
export const shiftReplaceList = (entity, client, id, start, end, contract = "", headerGroup) => apiUser.get(`/lov_tables/GetList_Nov_Turn_Replace/${entity}/${client}/${id}/${start}/${end}/${contract}`, { headers: headerGroup })
export const postShiftReplace = (payload, headerGroup) => apiUser.post(`/contract/PostContract_scheduling_replace`, payload, { headers: headerGroup })
export const postHolidayList = (payload, headerGroup) => apiUser.post(`/lov_tables/PostList_Turn_query_holiday`, payload, { headers: headerGroup })

/*Endpoint programación semana*/

export const programShifts = (payload, headerGroup) => apiUser.post('/upload/PostUpload_Contract_scheduling ', payload, { headers: headerGroup })

/*Endpoint filtro calendario*/

export const calendarTypeList = (client, entity, contrac_id, startDate, headerGroup) => apiUser.get(`/lov_tables/GetList_calendar_novelties/${client}/${entity}/${contrac_id}/${startDate}`, { headers: headerGroup })
/*Endpoints documentos*/

export const getDocumentList = (entity, client, headerGroup) => apiUser.get(`/lov_tables/GetList_create_document/${entity}/${client}`, { headers: headerGroup })
export const postDocument = (payload, headerGroup) => apiUser.post(`/contract/PostDocument_type`, payload, { headers: headerGroup })
export const getDocuments = (entity, client, number_id, headerGroup) => apiUser.get(`/contract/GetDocument_type/${entity}/${client}/${number_id}`, { headers: headerGroup })
export const delDocument = (entity, client, id, headerGroup) => apiUser.delete(`/contract/DelDocument_type/${entity}/${client}/${id}`, { headers: headerGroup })
export const getDocumentUrl = (entity, client, id, headerGroup) => apiUser.get(`/contract/GetUrl_s3_document_type/${entity}/${client}/${id}`, { headers: headerGroup })
export const verifySignature = (payload) => apiSecurity.post(`/python/VerifySignature`, payload)
export const documentSignature = (payload, headerGroup) => apiUser.post(`/Utility/PostFirmDocument`, payload, { headers: headerGroup })
export const pythonTest = (payload, method) => apiPython.post(`python/endpoint?method=${method}`, payload)

/*Endpoints notificaciones*/

export const getNotifications = (entity, client, headerGroup) => apiUser.get(`/warning/GetWarning_notification/${entity}/${client}`, { headers: headerGroup })
export const checkNotification = (payload, headerGroup) => apiUser.post(`/warning/PostWarning_notification_check`, payload, { headers: headerGroup })

/*Endpoints documentos contrato*/

export const getContractDocuments = (entity, client, contract, headerGroup) => apiUser.get(`/contract/GetDocument_type_contract/${entity}/${client}/${contract}`, { headers: headerGroup })
export const getContractFile = (entity, client, document, headerGroup) => apiUser.get(`/contract/GetUrl_s3_document_type_contract/${entity}/${client}/${document}`, { headers: headerGroup })
export const getContractSignature = (entity, client, contract, headerGroup) => apiUser.get(`/contract/GetContract_signature/${entity}/${client}/${contract}`, { headers: headerGroup })
export const putContractSignature = (payload, headerGroup) => apiUser.put(`/contract/PutDocument_type_contract_sign`, payload, { headers: headerGroup })

/*Endpoints dashboard*/

export const getBirthdays = (entity, client, headerGroup) => apiUser.get(`/process/GetBirthday_Employee/${entity}/${client}`, { headers: headerGroup })
export const getScheduling = (entity, client, headerGroup) => apiUser.get(`/process/GetScheduling_value_Employee/${entity}/${client}`, { headers: headerGroup })
export const getSchedulingConsolidate = (entity, client, headerGroup) => apiUser.get(`/process/GetScheduling_value_consolidate/${entity}/${client}`, { headers: headerGroup })
export const getMyEmployeesNow = (entity, client, headerGroup) => apiUser.get(`/process/GetMy_employee_now/${entity}/${client}`, { headers: headerGroup })
export const getAbsenceDays = (entity, client, headerGroup, entity_fil = -1, client_fil = -1) => apiUser.get(`/process/GetAbsence_days_employees/${entity}/${client}/${entity_fil}/${client_fil}`, { headers: headerGroup })

/*Endpoints gestión de usuarios*/

export const getSelfUsers = (entity, client, headerGroup) => apiUser.get(`/users/GetUser_selfservices_approver/${entity}/${client}`, { headers: headerGroup })
export const resetUser = (payload, headerGroup) => apiUser.post(`/users/PostReset_SelfService_user`, payload, { headers: headerGroup })
export const activateSelfUser = (payload, headerGroup) => apiUser.post(`/users/PostCreate_SelfService_user`, payload, { headers: headerGroup })

/*Endpoints reportes turnos*/

export const exportTurns = (payload, headerGroup) => apiUser.post(`/files_raw/PostReport_marking_shifts`, payload, { headers: headerGroup })
export const exportProgram = (payload, headerGroup) => apiUser.post(`/files_raw/PostReport_programmation_shifts`, payload, { headers: headerGroup })
export const exportNoProgram = (payload, headerGroup) => apiUser.post(`/files_raw/PostReport_without_shifts`, payload, { headers: headerGroup })
export const exportNoTurn = (payload, headerGroup) => apiUser.post(`/files_raw/PostReport_without_programmation`, payload, { headers: headerGroup })

/*Endpoint cargue marcaciones*/

export const postMarking = (payload, headerGroup) => apiUser.post(`/upload/PostUpload_Contract_marking_shifts`, payload, { headers: headerGroup })

/*Endpoint Actividades*/

export const exportActivities = (payload, headerGroup) => apiUser.post(`/files_raw/PostReport_activities`, payload, { headers: headerGroup })

/*Lista de endpoints*/

const apis = {
    postLogin,
    postFirm,
    getFirm,
    putFirm,
    deleteFirm,
    deleteVacation,
    saveUser,
    postIdentity,
    getValueListIdentity,
    putIdentity,
    postContract,
    putContract,
    getValueListContract,
    postBusiness,
    putBusiness,
    getBusiness,
    getValueListCompany,
    getValueListHolidays,
    getValueListCalendar,
    getValueFiles_raw,
    executeProcess,
    getBankFlat,
    getLastCalendar,
    getContracts_client,
    getOvertimeLists,
    getReportedLists,
    getLicensesLists,
    getIdentity,
    getContract,
    postOvertime,
    getOvertime,
    putOvertime,
    deleteOvertime,
    getNoveltiesCalendar,
    getVacation,
    postVacation,
    getVacationLists,
    putVacation,
    postReportVacationHistory,
    postReported,
    getReported,
    putReported,
    deleteReported,
    postLicenses,
    getLicenses,
    putLicenses,
    deleteLicenses,
    getLicenseEndDate,
    getEnd_DateVacation,
    postStatics,
    getStatics,
    putStatics,
    deleteStatics,
    getStaticsLists,
    getSocial_benefitsLists,
    postSocial_benefits,
    getSocial_benefits,
    putSocial_benefits,
    deleteSocial_benefits,
    getValidDateIni,
    postUsers,
    getUsers,
    putUsers,
    deleteUsers,
    getUsersList,
    postJobs,
    getJobs,
    putJobs,
    deleteJobs,
    getCenCosList,
    postCenCos,
    getCenCos,
    putCenCos,
    deleteCenCos,
    getAccountList,
    postAccount,
    getAccount,
    putAccount,
    deleteAccount,
    getValueListFirm,
    getValNit,
    getThirdList,
    getValueListPayrollConf,
    getPayrollConf,
    putPayrollConf,
    getPayrollGroupConf,
    postPayrollGroupConf,
    deletePayrollGroupConf,
    postThird,
    getThird,
    putThird,
    deleteThird,
    postReportPayroll,
    getConceptsPayrollConf,
    getToken,
    saveUserToken,
    getTimeNow,
    postReportCIR,
    postReportSocialSecurity,
    getCIRConfList,
    getCIRConf,
    postCIRConf,
    deleteCIRConf,
    postReportAccounting,
    postReportSeverance,
    postReportSalaryHistory,
    postReportHeadCount,
    PostChange_password,
    getLicenseExtension,
    getExecutedProcess,
    postReportLicenseHistory,
    getValueListReportedConcepts,
    postReportedConcept,
    getReportedConcept,
    putReportedConcept,
    deleteReportedConcept,
    getValueListOpenPayroll,
    postOpenPayroll,
    getValueListHistoricPayroll,
    postHistoricPayroll,
    getValueListHistoricSocialSecurity,
    postHistoricSocialSecurity,
    getValueListHistoricAccounting,
    postHistoricAccounting,
    getAccountListDocumentType,
    postReportAccount,
    postSendEmail,
    postUpdatePassword,
    getUserType,
    postReportElectronicPayroll,
    postSupportMail,
    getTransferDataElectronicPayroll,
    postTransferElectronicPayroll,
    getPayment,
    postPDF,
    postPDFVoucher,
    uploadHistoricPayroll,
    getListDIANProcess,
    postDIANProcess,
    putDIANProcess,
    getDIANProcess,
    putCune,
    putContractSalary,
    validateDIANProcess,
    postVerificationCode,
    getVerificationCode,
    getEpaycoParams,
    getEpaycoTransactions,
    postEpaycoTransaction,
    getCustomerInformation,
    postLegalTerms,
    confReport,
    getGetPayroll_budget,
    getGetEmployee_budget,
    GetPending_invoices,
    getPassiveLabor,
    getTotalPassiveLabor,
    getPayAbsenceType,
    getPayAbsenceDays,
    getVouchers,
    electronicPayrollConf,
    getCIRVouchers,
    postPDFCIRVoucher,
    postReportFlatSeverance,
    getFormat1009,
    getFormat2276,
    getReadDataElectronicPayroll,
    getInfoMessages,
    acceptTerms,
    getRetefuenteReports,
    postRetefuenteReport,
    getValidateCertificate,
    getRequestList,
    getRequest,
    getAllRequests,
    getVacationEndDate,
    postRequest,
    getPendRequests,
    putRequests,
    deleteRequest,
    requestGraph,
    getNovContracts,
    postFileS3,
    postCaptcha,
    activateUser,
    postInstanceAction,
    getInstanceLists,
    postImageRecognition,
    postTrackingNovelty,
    getEmployeesNovelties,
    getTrackingNovelties,
    getTrackingEmployees,
    getShiftsLists,
    getShifts,
    postShift,
    deleteShift,
    getRequestListAdd,
    programShifts,
    getDocumentList,
    getDocuments,
    postDocument,
    delDocument,
    getDocumentUrl,
    calendarTypeList,
    verifySignature,
    documentSignature,
    pythonTest,
    getNotifications,
    checkNotification,
    getContractDocuments,
    getContractFile,
    putContractSignature,
    getContractSignature,
    getBirthdays,
    getScheduling,
    getSchedulingConsolidate,
    getMyEmployeesNow,
    getAbsenceDays,
    noveltyCauseList,
    shiftReplaceList,
    postShiftReplace,
    getSelfUsers,
    resetUser,
    activateSelfUser,
    exportTurns,
    exportProgram,
    exportNoProgram,
    postMarking,
    exportNoTurn,
    postHolidayList,
    exportActivities,
}

export default apis;